import { createAction, props } from '@ngrx/store';
import { ApplicationListAndMetadataViewModel } from '../application-list-and-metadata/components/application-list-and-metadata/application-list-and-metadata.view-model';

const feature = '[Application list and metadata]';

export const fetchApplications = createAction(`${feature} fetch application`);
export const fetchApplicationsSuccess = createAction(
  `${feature} fetch application success`,
  props<{ applications: ApplicationListAndMetadataViewModel[] }>()
);
export const fetchApplicationsFail = createAction(`${feature} fetch application fail`, props<{ errorMessage: string }>());

export const updateApplication = createAction(
  `${feature} update application`,
  props<{ application: ApplicationListAndMetadataViewModel }>()
);
export const updateApplicationSuccess = createAction(
  `${feature} update application success`,
  props<{ application: ApplicationListAndMetadataViewModel }>()
);
export const updateApplicationFail = createAction(`${feature} update application fail`, props<{ errorMessage: string }>());

export const removeApplication = createAction(
  `${feature} remove application`,
  props<{ application: ApplicationListAndMetadataViewModel }>()
);
export const removeApplicationSuccess = createAction(`${feature} remove application success`);
export const removeApplicationFail = createAction(`${feature} remove application fail`, props<{ errorMessage: string }>());
